// eslint-disable-next-line import/no-cycle
import { isUserLoggedIn } from '@/auth/utils'

export default function isAuthenticated({ next, router }) {
  if (!isUserLoggedIn()) {
    return router.push('login')
  }
  return next()
}
